import { combineReducers } from 'redux';

import backup from './backup/backupReducer';

export default combineReducers({
	backup,
});
